import { render, staticRenderFns } from "./OrderCancelModal.vue?vue&type=template&id=495c93c4&"
import script from "./OrderCancelModal.vue?vue&type=script&lang=js&"
export * from "./OrderCancelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports